import MailingInformation from './MailingInformation';

export default MailingInformation;
